import { useCallback } from 'react';
import { usePartnerDataClient } from '../api/use-partner-data-client';
import { ActionsCatalog, ActionTypeDefinition } from '../domain/types';

import { useAsyncResource } from './use-async-resource';

const EMPTY_CATALOG: ActionsCatalog = { actionTypes: [] };

export interface UseActionsCatalogReturn {
  catalog: ActionsCatalog;
  /** Convenience alias — every caller works off the action type list. */
  actionTypes: ActionTypeDefinition[];
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
}

/**
 * Fetches the action type catalog that drives the Action Builder's type
 * dropdown and its per-type metadata fields. PDGS owns both the list and
 * each type's field schema, so nothing about them is hardcoded in the UI.
 */
export const useActionsCatalog = (): UseActionsCatalogReturn => {
  const client = usePartnerDataClient();

  const fetchCatalog = useCallback(() => client.getActionsCatalog(), [client]);

  const { data, isLoading, hasError, refetch } = useAsyncResource(
    fetchCatalog,
    EMPTY_CATALOG,
  );

  return {
    catalog: data,
    actionTypes: data.actionTypes,
    isLoading,
    hasError,
    refetch,
  };
};
